import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-modal-footer',
  templateUrl: './mobile-modal-footer.component.html'
})
export class MobileModalFooterComponent implements OnInit {
  constructor() {}

  private transform = false;
  ngOnInit(): void {}
}
